<script lang="ts" setup>
import { useCustomerStore } from '@stores/me/customer'
import { useAssessmentResultStore } from '@stores/assessment-result'

import { LoaderFullScreenDomain } from '@UI/Loaders/LoaderFullScreenDomain'
import GateScope from '@Widgets/Scope/GateScope.vue'

defineOptions({
  name: 'LayoutAssessmentResult',
})

const customerStore = useCustomerStore()
const assessmentResultStore = useAssessmentResultStore()

const isLoading = computed(() => !customerStore.hasData || assessmentResultStore.isLoading || !assessmentResultStore.getQuestions.length)
</script>

<template>
  <div
    v-if="!isLoading"
    :class="['assessment-catch-up', assessmentResultStore.getVariant]"
  >
    <div
      v-if="$slots.header"
      class="assessment-catch-up__header"
    >
      <slot name="header" />
    </div>
    <div class="assessment-catch-up__main">
      <div
        v-if="$slots.info"
        class="assessment-catch-up__info"
      >
        <slot name="info" />
      </div>
      <div class="assessment-catch-up__content">
        <GateScope>
          <slot />
        </GateScope>
      </div>
    </div>
    <div
      v-if="$slots.footer"
      class="assessment-catch-up__footer"
    >
      <slot name="footer" />
    </div>
  </div>
  <LoaderFullScreenDomain v-else />
</template>

<style scoped lang="scss" src="@scss/layouts/assessment-catch-up.scss" />
